import WidgetService, { createClient } from './WidgetService';
import SalesforceWidgetClient from '../../clients/SalesforceWidgetClient';

class SalesforceWidgetService extends WidgetService {
  constructor() {
    super({ name: 'SalesforceWidgetService', client: SalesforceWidgetClient });
    this.widgetDeleteConnectionClient = null;
    this.widgetExplorerClient = null;
    this.widgetObjectClient = null;
    this.widgetFieldClient = null;
    this.widgetSearchClient = null;
  }

  async deleteConnection() {
    const client = () => {
      if (!this.widgetDeleteConnectionClient) {
        this.widgetDeleteConnectionClient = createWidgetDeleteConnectionClient(this.WidgetClient);
      }
      return this.widgetDeleteConnectionClient;
    };

    return this.delete(client, 'Couldn\'t delete widget connection', 'widgetDeleteConnection');
  }

  async testConnection() {
    try {
      await this.getSearchResults('test');
      return true;
    } catch (error) {
      this.logError(`Widget Connection did not work! ${error}`);
    }
    return false;
  }

  async getExplorer() {
    const client = () => {
      if (!this.widgetExplorerClient) {
        this.widgetExplorerClient = createWidgetExplorerClient(this.WidgetClient);
      }
      return this.widgetExplorerClient;
    };

    return this.get(client, 'widgetExplorerResponse');
  }

  async getObject(exploreObject) {
    const client = () => {
      this.widgetObjectClient = createWidgetObjectClient(this.WidgetClient, exploreObject);
      return this.widgetObjectClient;
    };

    return this.get(client, 'widgetObjectResponse');
  }

  async getField(exploreObject, exploreField) {
    const client = () => {
      this.widgetFieldClient = createWidgetFieldClient(this.WidgetClient, exploreObject, exploreField);
      return this.widgetFieldClient;
    };

    return this.get(client, 'widgetFieldResponse');
  }

  async getSearchResults(searchPhrase) {
    const client = () => {
      this.widgetSearchClient = createWidgetSearchClient(this.WidgetClient, searchPhrase);
      return this.widgetSearchClient;
    };

    return this.get(client, 'widgetSearchResponse');
  }
}

function createWidgetDeleteConnectionClient(Client) {
  return createClient(
    'widgetDeleteConnectionClient',
    'DeleteWidgetConnectionConfiguration',
    Client.RESOURCES.WIDGET_DELETE_CONNECTION,
    Client,
  );
}

function createWidgetExplorerClient(Client) {
  return createClient(
    'createWidgetExplorerClient',
    'GetWidgetExplorerConfiguration',
    Client.RESOURCES.WIDGET_EXPLORER,
    Client,
  );
}

function createWidgetObjectClient(Client, exploreObject) {
  return createClient(
    'createWidgetObjectClient',
    'GetWidgetObjectConfiguration',
    Client.RESOURCES.WIDGET_OBJECT,
    Client,
    { exploreObject },
  );
}

function createWidgetFieldClient(Client, exploreObject, exploreField) {
  return createClient(
    'createWidgetFieldClient',
    'GetWidgetFieldConfiguration',
    Client.RESOURCES.WIDGET_FIELD,
    Client,
    { exploreObject, exploreField },
  );
}

function createWidgetSearchClient(Client, searchPhrase) {
  return createClient(
    'createWidgetSearchClient',
    'GetWidgetSearchConfiguration',
    Client.RESOURCES.WIDGET_SEARCH,
    Client,
    { searchPhrase },
  );
}

const salesforceWidgetService = new SalesforceWidgetService();
export { salesforceWidgetService };

export default SalesforceWidgetService;
